<span
  [class.asc]="getDirection() === 'asc'"
  [class.desc]="getDirection() === 'desc'"
>
  <ng-content></ng-content>
</span>
